import { render, staticRenderFns } from "./roleSelect.vue?vue&type=template&id=55cda452&scoped=true&"
import script from "./roleSelect.vue?vue&type=script&lang=js&"
export * from "./roleSelect.vue?vue&type=script&lang=js&"
import style0 from "./roleSelect.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./roleSelect.vue?vue&type=style&index=1&id=55cda452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cda452",
  null
  
)

export default component.exports